import React, {useEffect, useRef, useState} from "react";
import {Col, Row, Spinner} from "react-bootstrap";
import {apolloClientReports} from "../../../GraphQL/config";
import moment from "moment/moment";

import {getLastMonthEndDate, getLastMonthStartDate, gqlDateFormat} from "../Utils/utils";
import {QUERY_GET_WATER_SYSTEM_CONSUMPTION_SITE_DATA_TABLE} from "../../../GraphQL/ReportGenerator/queries";
import WaterConsumptionTable from "../WaterConsumptionTable/WaterConsumptionTable";
import {numberFormatter, tableTextFilter} from "../../Table/Table";
import convert, {DEFAULT_VOLUME_UNIT} from '../MeasurementText/MeasurementTextConverter';

export default function WaterSystemConsumptionDataTable(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [tableData, setTableData] = useState();
    const [startDate, setStartDate] = useState(getLastMonthStartDate());
    const [endDate, setEndDate] = useState(getLastMonthEndDate());
    const [csvData, setCsvData] = useState([]);
    const [volumeUnit, setVolumeUnit] = useState(DEFAULT_VOLUME_UNIT);
    const [dateApplied, setDateApplied] = useState(true);

    const entityType = props.entityLabel;
    const headerStyle = {fontSize: 11}
    const colStyle = {fontSize: 13, padding: '1px', verticalAlign: 'center'}

    const queryWaterConsumptionData = () => {
        apolloClientReports.query({
            query: QUERY_GET_WATER_SYSTEM_CONSUMPTION_SITE_DATA_TABLE, variables: {
                from: gqlDateFormat(startDate),
                to: gqlDateFormat(endDate),
                entityType: entityType
            }
        }).then(res => {
            let response = res?.data?.waterConsumptionAndLeakWasteDatatable;
            if (!response) {
                console.error(`Data from WaterConsumptionDataTable is empty`);
            } else {
                setVolumeUnit(convert(response.measureUnit.volumeUnit));
                setTableData(response);
                setCsvData(buildCsvData(response.data));
                setIsLoading(false);
            }
        })
    }

    const filtersRefs = useRef([]);

    const columns = [
        {dataField: 'siteName', text: 'Site Name', headerStyle: headerStyle, style: colStyle, sort: true, filter: tableTextFilter(filtersRefs)},
        {dataField: 'name', text: 'Water System Name', headerStyle: headerStyle, style: colStyle, sort: true, filter: tableTextFilter(filtersRefs)},
        {dataField: 'waterConsumption', text: `Water Consumption (${volumeUnit})`, headerStyle: headerStyle, style: colStyle, sort: true, formatter: numberFormatter},
        {dataField: 'leaksVolume', text: `Leaks Volume (${volumeUnit})`, headerStyle: headerStyle, style: colStyle, sort: true, formatter: numberFormatter},
        {dataField: 'potentialWaste', text: `Potential Waste (${volumeUnit})`, headerStyle: headerStyle, style: colStyle, sort: true, formatter: numberFormatter},
        {dataField: 'totalAlerts', text: 'Number of Alerts', headerStyle: headerStyle, style: colStyle, sort: true, formatter: numberFormatter},
        {dataField: 'leaksRatio', text: 'Leaks & Actual Use Ratio (%)', headerStyle: headerStyle, style: colStyle, sort: true, formatter: numberFormatter}
    ]

    const buildCsvData = (responseData) => {
        const csvData = [];
        const headers = [
            'From',
            'To',
            'Water System Name',
            'Site Name',
            'Water consumption',
            'Leaks volume',
            'Potential waste',
            'Number of alerts',
            'Leaks and actual use ratio'
        ];
        csvData.push(headers);

        responseData.forEach((entity, index) => {
            const row = [];
            if (index === 0) {
                row.push(moment(startDate).format('LL'), moment(endDate).format('LL'));
            } else {
                row.push('', '');
            }
            row.push(entity.name, entity.siteName, entity.name, entity.waterConsumption, entity.leaksVolume, entity.potentialWaste, entity.totalAlerts, entity.leaksRatio);
            csvData.push(row);
        });

        return csvData;
    }

    useEffect(() => {
        if (dateApplied) {
            setIsLoading(true);
            queryWaterConsumptionData();
            setDateApplied(false);
        }
    }, [dateApplied])

    return (
        <>
            {!tableData && <Spinner animation="border" variant="primary"/>}
            {tableData &&
                <Row>
                    <Col md={12}>
                        <p className={'card-title-main bold-title'}>{props.title}</p>
                    </Col>
                    {isLoading && <Spinner animation="border" variant="primary"/>}
                    {!isLoading &&
                        <>
                            <Col md={12}>
                                <WaterConsumptionTable data={tableData} startDate={startDate} endDate={endDate}
                                                       setStartDate={setStartDate} setEndDate={setEndDate}
                                                       setDateApplied={setDateApplied}
                                                       columns={columns} csvData={csvData} filtersRefs={filtersRefs}
                                                       title={`Water consumption data by ${entityType}s`}/>
                            </Col>
                        </>
                    }
                </Row>
            }
        </>
    )
}
